import {initConfig} from "./config.js";
import { registerSettings } from "./settings.js";

export const MODULE_ID = "side-quest-society-premium";

Hooks.on("init", () => {
    initConfig();
    registerSettings();
});